import ApplicationContentClient from '../common/ApplicationContentClient';

export class Idel2ApplicationContentClient extends ApplicationContentClient {
    static ASSESSMENT = 'Lectura';

    // for future integration with secure content
    static ASSESSMENT_SHORT_NAME = 'LECTURA';

    static BASE_CONTENT_URL = '/idel2-api/content/v1';

    static BASE_STATIC_CONTENT_URL = '/espanol-assessment/static/content';
}

export default Idel2ApplicationContentClient;
